import styled from 'styled-components';

const StyledContainer = styled.div<{ $active: boolean }>`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		transition: filter 0.3s ease;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
	}

	&:hover {
		img {
			filter: invert(100%);
			opacity: 1;
		}
	}
`;

const StyledInput = styled.input`
	width: 100%;
	height: 50px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	padding: 0 60px 0 20px;
	border: 0;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
	}

	&:focus {
		outline: none;
	}

	&:hover,
	&:active,
	&:focus {
		background-color: rgba(255, 255, 255, 1);
		color: #000000;

		& + img {
			filter: invert(100%);
		}

		&::placeholder {
			color: rgba(0, 0, 0, 0.5);
		}
	}
`;

export { StyledContainer, StyledInput };
